import styled from '@emotion/styled'
import { t } from '@lingui/core/macro'
import CachedIcon from '@mui/icons-material/Cached'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

const FullWidth = styled.div`
  width: 100%;
  margin-top: 15px;
`
const MarginTypography = styled(Typography)`
  margin-top: 3px;
`

interface Props {
  resetMappings: () => void
}

export const FieldMappingReset = ({ resetMappings }: Props) => (
  <FullWidth>
    <Button startIcon={<CachedIcon />} color="primary" onClick={resetMappings} variant="outlined">
      {t`Reset field mapping`}
    </Button>
    <MarginTypography variant="body2">
      {t`This will reset your mappings to match the mappings currently configured on the inbound integration.`}
    </MarginTypography>
  </FullWidth>
)
